import React from 'react'

const SuspenseLoader = () => {
    return (
        <div>loading ....... </div>
    )
}

export default SuspenseLoader